import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  AdminTestConditionOption,
  AdminTestPatientEnsureRequest,
  AdminTestPatientStatus,
  AdminTestReport,
  AdminTestReportPdf,
  AdminTestReportRequest,
} from '@chiroup/core/types/AdminTestPatient.type';

const testPatientService = {
  status: (clinicId: number): Promise<AdminTestPatientStatus> =>
    ChiroUpAPI.get('api', `/clinics/${clinicId}/test-patient`, {}),
  ensure: (
    clinicId: number,
    body: AdminTestPatientEnsureRequest
  ): Promise<AdminTestPatientStatus> =>
    ChiroUpAPI.post('api', `/clinics/${clinicId}/test-patient`, { body }),
  conditions: (clinicId: number): Promise<AdminTestConditionOption[]> =>
    ChiroUpAPI.get('api', `/clinics/${clinicId}/test-patient/conditions`, {}),
  createReport: (clinicId: number, body: AdminTestReportRequest): Promise<AdminTestReport> =>
    ChiroUpAPI.post('api', `/clinics/${clinicId}/test-patient/reports`, { body }),
  pdf: (clinicId: number, reportId: number): Promise<AdminTestReportPdf> =>
    ChiroUpAPI.get('api', `/clinics/${clinicId}/test-patient/reports/${reportId}/pdf`, {}),
};
export default testPatientService;
